import { toPng, toJpeg } from 'html-to-image';
import { jsPDF } from 'jspdf';
import { useEffect } from 'react';
import { showError } from '../services/reactToastify';

export default function ExportMenu({ onClose }) {

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (!e.target.closest('.export-menu')) onClose();
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [onClose]);

    const exportToPDF = async () => {
        try {
            const element = document.getElementById('main-content');
            if (!element) return showError("Main content not found");

            // Generate high-quality image
            const dataUrl = await toPng(element, {
                quality: 1,
                pixelRatio: 2,
                backgroundColor: '#09090b',
            });

            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a4'
            });

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            // Get image dimensions
            const img = new Image();
            img.src = dataUrl;

            img.onload = () => {
                const imgWidth = img.width;
                const imgHeight = img.height;
                const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);

                const finalWidth = imgWidth * ratio;
                const finalHeight = imgHeight * ratio;

                const x = (pdfWidth - finalWidth) / 2;
                const y = (pdfHeight - finalHeight) / 2;

                pdf.addImage(dataUrl, 'PNG', x, y, finalWidth, finalHeight);
                pdf.save(`AetherForge_Report_${new Date().toISOString().slice(0, 10)}.pdf`);

                onClose();
            };
        } catch (error) {
            console.error("PDF Error:", error);
            showError("PDF generation failed. Try Screenshot instead.");
        }
    };

    const takeScreenshot = async () => {
        try {
            const element = document.getElementById('main-content');

            const dataUrl = await toPng(element, {
                quality: 1,
                pixelRatio: 2,
                backgroundColor: '#09090b',
            });

            const link = document.createElement('a');
            link.download = `AetherForge_Screenshot_${new Date().toISOString().slice(0, 10)}.png`;
            link.href = dataUrl;
            link.click();

            onClose();
        } catch (error) {
            console.error(error);
            showError("Failed to take screenshot");
        }
    };

    const exportToCSV = () => {
        const csvData = [
            ["Task", "Status", "Assignee", "Due Date", "Priority"],
            ["Implement AI Forge", "Done", "MK", "2026-05-16", "High"],
            ["Workspace Export", "In Progress", "You", "2026-05-18", "Medium"],
        ];

        const csvContent = "data:text/csv;charset=utf-8," +
            csvData.map(row => row.join(",")).join("\n");

        const link = document.createElement("a");
        link.href = encodeURI(csvContent);
        link.download = "aetherforge_data.csv";
        link.click();
        onClose();
    };

    return (
        <div className="export-menu absolute right-0 mt-2 bg-zinc-900 border border-zinc-700 rounded-2xl shadow-2xl z-50 w-64 py-2 text-sm">
            <div className="px-4 py-3 text-zinc-400 text-xs font-medium border-b border-zinc-800">EXPORT OPTIONS</div>

            <button onClick={exportToPDF} className="w-full cursor-pointer text-left px-6 py-3 hover:bg-zinc-800 flex items-center gap-3">
                📄 Export as PDF
            </button>

            <button onClick={takeScreenshot} className="w-full cursor-pointer text-left px-6 py-3 hover:bg-zinc-800 flex items-center gap-3">
                📸 Take Screenshot
            </button>

            <button onClick={exportToCSV} className="w-full cursor-pointer text-left px-6 py-3 hover:bg-zinc-800 flex items-center gap-3">
                📊 Export as CSV
            </button>
        </div>
    );
}